import React, { useEffect, useState } from "react";
import { ProductContext } from "./index";
import { PostData } from "../services/FetchData";
import { startOfMonth } from "date-fns";
import Cookies from "js-cookie";

const ADMIN_PRODUCT_TYPES = [
	"search",
	"aiassistant",
	"cmsassistant",
	"aivisibility",
];

const ProductProvider = props => {
	const [userData, setUserData]	= useState({}),
		[adminData, setAdminData] = useState(null),
		[userLoader, setUserLoader]	= useState(true),
		[websiteData, setWebsiteData]	= useState({}),
		[userWebsitePlan, setUserWebsitePlan]	= useState(null),
		[productTypes, setProductTypes]	= useState([]),
		[currentWebsiteId, setCurrentWebsiteId]	= useState(null),
		[websiteLoader, setWebsiteLoader]	= useState(true),
		[usersList, setUsersList] = useState([]),
		[usersLoader, setUsersLoader] = useState(false),
		[selectedUserId, setSelectedUserId] = useState(null),
		[storesLoader, setStoresLoader] = useState(false),
		[addPageOpen, setAddPageOpen] = useState(false),
		[loadVisualEditor, setLoadVisualEditor]	= useState(false),
		[products, setProducts]	= useState([]),
		[categoryId, setCategoryId]	= useState(null),
		[originalProductOrder, setOriginalProductOrder]	= useState(new Map()),
		[categories, setCategories]	= useState([]),
		[description, setDescription]	= useState(""),
		[productLoader, setProductLoader]	= useState(false),
		[productCount, setProductCount]	= useState(null),
		[productPage, setProductPage]	= useState(1),
		[pagePerProducts, setPagePerProducts]	= useState(10),
		[enableSave, setEnableSave]	= useState(false),
		[rowPerProducts, setRowPerProducts]	= useState(4),
		[shopCurrency, setShopCurrency]	= useState('USD'),
		[hasMore, setHasMore]	= useState(false),
		[productOrder, setProductOrder]	= useState(new Map()),
		[newProductOrder, setNewProductOrder]	= useState(new Map()),
		[promoted, setPromoted]	= useState([]),
		[buried, setBuried]	= useState([]),
		[hidden, setHidden]	= useState([]),
		[buriedProducts, setBuriedProducts]	= useState([]),
		[hiddenProducts, setHiddenProducts]	= useState([]),
		[saveLoader, setSaveLoader]	= useState(false),
		[categoryIds, setCategoryIds]	= useState([]),
		[pinnedItems, setPinnedItems]	= useState({}),
		[originalProducts, setOriginalProducts]	= useState([]),
		[hiddenProductIndex, setHiddenProductIndex]	= useState({}),
		[activeItem, setActiveItem] = useState(null),
		[editCategoryMerchandising, setEditCategoryMerchandising]	= useState(null),
		[searchPhrase, setSearchPhrase]	= useState(""),
		[editSearchPhraseMerchandising, setEditSearchPhraseMerchandising]	= useState(null),
		[editLandingPageMerchandising, setEditLandingPageMerchandising]	= useState(null),
		[addedProductIds, setAddedProductIds]	= useState([]),
		[addedProducts, setAddedProducts]	= useState({}),
		[exact, setExact]	= useState(true),
		[platForm, setPlatForm]	= useState(""),
		[editorPageFlag, setEditorPageFlag]	= useState(false),
		[pageLoader, setPageLoader]	= useState(false),
		[activeMenu, setActiveMenu]	= useState('general'),
		[pinnedProductIndex, setPinnedProductIndex]	= useState({}),
		[magentoStoreViewsLoader, setMagentoStoreViewsLoader]	= useState(true),
		[websitePlatform, setWebsitePlatform]	= useState(""),
		[defaultStoreView, setDefaultStoreView]	= useState(""),
		[magentoStoreViews, setMagentoStoreViews]	= useState({}),
		[landingPageSearchPhrase, setLandingPageSearchPhrase]	= useState(""),
		[landingPageId, setLandingPageId]	= useState(null),
		[searchPhraseModal, setSearchPhraseModal] = useState(false),
		[loadOriginalProduct, setLoadOriginalProduct]	= useState(false),
		[landingPageFilter, setLandingPageFilter]	= useState([]),
	   [banners, setBanners] = useState([]),
	   [banner, setBanner] = useState(null),
      [selectedBanner, setSelectedBanner] = useState(null),
		[bannerLoader, setBannerLoader]	= useState(false),
		[channels, setChannels] = useState([]),
		[channelsLoader, setChannelsLoader] = useState(true),
	   [selectedBannerId, setSelectedBannerId] = useState(null),
		[channelId, setChannelId]	= useState("1"),
		[debouncedSearch, setDebouncedSearch]	= useState(""),
		[merchandisingError, setMerchandisingError]	= useState(""),
		[promoTileLoader, setPromoTileLoader]	= useState(false),
		[promoTiles, setPromoTiles]	= useState([]),
		[selectedPromoTiles, setSelectedPromoTiles]	= useState({}),
		[enableDynamic, setEnableDynamic]	= useState(false),
		[dynamicItems, setDynamicItems]	= useState({}),
		[newProducts, setNewProducts]	= useState([]),
		[triggerDynamic, setTriggerDynamic]	= useState(false),
		[dateRange, setDateRange] = useState({
			startDate: startOfMonth(new Date()),
			endDate: new Date(),
			key: "selection",
		}),
		// Filter-related state
		[filterValues, setFilterValues]	= useState([]),
		[currentFilter, setCurrentFilter]	= useState(null)

	// ---------------- Admin portal helpers (all websites selection) ----------------

	const buildWebsiteMap = (websites) => {
		const map = {};
		(websites || []).forEach((w) => {
			if (w && w.websiteId !== undefined && w.websiteId !== null) {
				const id = parseCookieId(w.websiteId);
				if (id) {
					map[id] = w;
				}
			}
		});
		return map;
	};

	const parseCookieId = (value) => {
		if (value === null || value === undefined || value === "") {
			return null;
		}
		const parsed = parseInt(value, 10);
		return Number.isFinite(parsed) ? parsed : null;
	};

	const getWebsiteFromMap = (websiteMap, websiteId) => {
		const id = parseCookieId(websiteId);
		if (!id || !websiteMap) {
			return null;
		}
		return websiteMap[id] ?? websiteMap[String(id)] ?? null;
	};

	const applyWebsiteSelection = (websiteMap, websiteId) => {
		const id = parseCookieId(websiteId);
		const website = getWebsiteFromMap(websiteMap, id);
		if (!id || !website) {
			return false;
		}
		Cookies.set("_website_id", String(id));
		setCurrentWebsiteId(id);
		setUserWebsitePlan(website.websiteUserPlan || []);
		setProductTypes(ADMIN_PRODUCT_TYPES);
		return true;
	};

	const setDefaultStoreFromWebsites = (websites, websiteIdToSelect = null) => {
		const websiteMap = buildWebsiteMap(websites);
		if (!websites || websites.length === 0) {
			setWebsiteData({});
			setCurrentWebsiteId(null);
			setUserWebsitePlan([]);
			setProductTypes([]);
			Cookies.remove("_website_id");
			return;
		}
		setWebsiteData(websiteMap);
		const targetWebsiteId =
			parseCookieId(websiteIdToSelect) ?? parseCookieId(Cookies.get("_website_id"));
		if (applyWebsiteSelection(websiteMap, targetWebsiteId)) {
			return;
		}
		// Keep admin-selected cookie id even if it is not in the loaded map yet
		if (targetWebsiteId) {
			Cookies.set("_website_id", String(targetWebsiteId));
			setCurrentWebsiteId(targetWebsiteId);
			setUserWebsitePlan([]);
			setProductTypes(ADMIN_PRODUCT_TYPES);
			return;
		}
		// Prefer a website that has search enabled (avoids landing on a non-search store)
		const preferredWebsite =
			(websites || []).find((w) => Array.isArray(w?.productsMapping) && w.productsMapping.includes("search")) ||
			websites[0];
		applyWebsiteSelection(websiteMap, preferredWebsite.websiteId);
	};

	const selectWebsiteForAdmin = (websiteId) => {
		const normalizedWebsiteId = parseCookieId(websiteId);
		if (!normalizedWebsiteId) {
			return;
		}

		if (applyWebsiteSelection(websiteData, normalizedWebsiteId)) {
			return;
		}

		Cookies.set("_website_id", String(normalizedWebsiteId));
		setCurrentWebsiteId(normalizedWebsiteId);
		setProductTypes(ADMIN_PRODUCT_TYPES);
		setUserWebsitePlan([]);
	};

	const loadAllAdminWebsites = async () => {
		const websitesRes = await PostData("ms1", "api/v1/admin/websites", {});
		if (websitesRes?.status === "success") {
			return websitesRes.data.websites || [];
		}

		const usersRes = await PostData("ms1", "api/v1/admin/users", {});
		const users = usersRes?.status === "success" ? (usersRes.data.users || []) : [];
		const websiteById = new Map();

		for (const user of users) {
			const res = await PostData("ms1", "api/v1/admin/userWebsites", {
				userId: user.userId,
			});
			if (res?.status !== "success") {
				continue;
			}
			for (const website of res.data.websites || []) {
				const id = parseCookieId(website?.websiteId);
				if (id) {
					websiteById.set(id, website);
				}
			}
		}

		return [...websiteById.values()].sort(
			(a, b) => parseCookieId(a.websiteId) - parseCookieId(b.websiteId)
		);
	};

	const adminBootstrap = async () => {
		setUserLoader(true);
		setWebsiteLoader(true);

		try {
			const meRes = await PostData("ms1", "api/v1/admin/me", {});
			if (meRes && meRes.status === "success") {
				setAdminData(meRes.data.admin);
				setUserData({
					...meRes.data.admin,
					userId: meRes.data.admin?.adminId ?? meRes.data.admin?.userId ?? 1,
				});
			}

			const websites = await loadAllAdminWebsites();
			setDefaultStoreFromWebsites(websites);
		} finally {
			setWebsiteLoader(false);
			setUserLoader(false);
		}
	};
	
	useEffect(() => {
		if( websiteData && currentWebsiteId ){
			if( typeof websiteData[currentWebsiteId] !== "undefined" && websiteData[currentWebsiteId] ){
				setWebsitePlatform(websiteData[currentWebsiteId]?.websiteType || "")
				setUserWebsitePlan(websiteData[currentWebsiteId]?.websiteUserPlan || [])
				console.log(websiteData[currentWebsiteId]?.websiteType === "bigcommerce", websiteData[currentWebsiteId]?.websiteUserPlan < 4, websiteData[currentWebsiteId]?.websiteUserPlan)
				// Super admin portal: always expose all product rails
				const productsMapping = Array.isArray(websiteData[currentWebsiteId]?.productsMapping) 
					? websiteData[currentWebsiteId].productsMapping 
					: []
				setProductTypes(ADMIN_PRODUCT_TYPES)
				if( websiteData[currentWebsiteId].websiteType === "magento" ){
					// Use the getStoreViews endpoint
					PostData("ms2", "api/v1/magento/getStoreViews", {websiteId:currentWebsiteId}).then(result => {
						if( result !== "Invalid" && result !== "undefined" ){
							if( result.status === "success" ){
								// Handle new format (array of store views)
								if( result.data.storeViews && Array.isArray(result.data.storeViews) ){
									let storeViewObj = {};
									result.data.storeViews.forEach(sv => {
										if( sv.code ){
											storeViewObj[sv.code] = sv.name || sv.code;
										}
									});
									setMagentoStoreViews(storeViewObj);
									if( Object.keys(storeViewObj).length > 0 ){
										setDefaultStoreView(Object.keys(storeViewObj)[0]);
									}
								} else if( result.data.storeViewObj ){
									// Handle old format (object) for backward compatibility
									let storeViewObj = result.data.storeViewObj;
									setMagentoStoreViews(storeViewObj);
									if( Object.keys(storeViewObj).length > 0 ){
										setDefaultStoreView(Object.keys(storeViewObj)[0]);
									}
								}
								setMagentoStoreViewsLoader(false);
							}
						} else {
							setMagentoStoreViewsLoader(false);
						}
					}).catch(error => {
						console.error("Error fetching Magento store views:", error);
						setMagentoStoreViewsLoader(false);
					})
				}else if( websiteData[currentWebsiteId]?.websiteType === "bigcommerce" && Array.isArray(productsMapping) && productsMapping.indexOf("search") !== -1 ){
					PostData("ms3", "api/v1/admin/bigcommerce/getChannels", {websiteId: currentWebsiteId}).then(result => {
						if( result !== "Invalid" && result !== "undefined" && result ){
							console.log(result);
							if( result.status === "success" && result.data && Array.isArray(result.data.channels) ){
								setChannels(result.data.channels)
							}
							setChannelsLoader(false)
						} else {
							setChannelsLoader(false);
						}
					}).catch(error => {
						console.error("Error fetching BigCommerce channels:", error);
						setChannelsLoader(false);
					})
				} else {
					// WooCommerce, Shopify, Drupal, etc. do not use channels; allow list pages to load
					setChannelsLoader(false);
				}
			}
		}
	}, [currentWebsiteId, websiteData])
	
	// Filter-related functions
	const getFilteredValues = (filterId) => {
		if (!filterId) return filterValues
		return filterValues.filter(item => item.filterId === filterId)
	}


  const updateFilterValues = (newValues) => {
    console.log("ProductProvider: Updating filter values:", newValues);
    setFilterValues(newValues);
  };

  const updateCurrentFilter = (newFilter) => {
    console.log("ProductProvider: Updating current filter:", newFilter);
    setCurrentFilter(newFilter);
  };

  const applySortingToValues = (values, sortType) => {
    if (!values || values.length === 0) return values;

    let sorted = [...values];

    console.log("ProductProvider: Applying sorting with sortType:", sortType);

    switch (sortType) {
      case "nameAsc":
        sorted.sort((a, b) =>
          (a.displayName || a.value || a.value1 || "").localeCompare(
            b.displayName || b.value || b.value1 || "",
          ),
        );
        break;
      case "nameDesc":
        sorted.sort((a, b) =>
          (b.displayName || b.value || b.value1 || "").localeCompare(
            a.displayName || a.value || a.value1 || "",
          ),
        );
        break;
      case "manual":
        sorted.sort((a, b) => (a.pos || 0) - (b.pos || 0));
        break;
      default:
        // Default order
        break;
    }

    console.log("ProductProvider: Final sorted values:", sorted);
    return sorted;
  };

  const store = {
    pageLoader,
    setPageLoader,
    editorPageFlag,
    setEditorPageFlag,
    activeMenu,
    setActiveMenu,
    userData,
    setUserData,
		adminData,
		setAdminData,
    userLoader,
    setUserLoader,
    websiteData,
    websiteLoader,
    setWebsiteLoader,
    originalProductOrder,
    setOriginalProductOrder,
    setWebsiteData,
    currentWebsiteId,
    setCurrentWebsiteId,
    originalProducts,
    setOriginalProducts,
    addPageOpen,
    setAddPageOpen,
    products,
    setProducts,
    description,
    setDescription,
    categoryId,
    setCategoryId,
    categories,
    setCategories,
    productLoader,
    setProductLoader,
    productPage,
    setProductPage,
    productCount,
    setProductCount,
    enableSave,
    setEnableSave,
    pagePerProducts,
    setPagePerProducts,
    rowPerProducts,
    setRowPerProducts,
    shopCurrency,
    setShopCurrency,
    hiddenProductIndex,
    setHiddenProductIndex,
    hasMore,
    setHasMore,
    productOrder,
    setProductOrder,
    promoted,
    setPromoted,
    buried,
    setBuried,
    hidden,
    setHidden,
    buriedProducts,
    setBuriedProducts,
    hiddenProducts,
    setHiddenProducts,
    saveLoader,
    setSaveLoader,
    categoryIds,
    setCategoryIds,
    activeItem,
    setActiveItem,
    editCategoryMerchandising,
    setEditCategoryMerchandising,
    loadVisualEditor,
    setLoadVisualEditor,
    pinnedItems,
    setPinnedItems,
    searchPhrase,
    setSearchPhrase,
    pinnedProductIndex,
    setPinnedProductIndex,
    editSearchPhraseMerchandising,
    setEditSearchPhraseMerchandising,
    exact,
    setExact,
    platForm,
    setPlatForm,
    magentoStoreViews,
    magentoStoreViewsLoader,
    websitePlatform,
    defaultStoreView,
    setDefaultStoreView,
    landingPageSearchPhrase,
    setLandingPageSearchPhrase,
    landingPageFilter,
    setLandingPageFilter,
    landingPageId,
    setLandingPageId,
    editLandingPageMerchandising,
    setEditLandingPageMerchandising,
    searchPhraseModal,
    setSearchPhraseModal,
    loadOriginalProduct,
    setLoadOriginalProduct,
    banners,
    setBanners,
    selectedBanner,
    banner,
    setBanner,
    setSelectedBanner,
    selectedBannerId,
    setSelectedBannerId,
    userWebsitePlan,
    setUserWebsitePlan,
    productTypes,
    setProductTypes,
		usersList,
		setUsersList,
		usersLoader,
		setUsersLoader,
		selectedUserId,
		setSelectedUserId,
		storesLoader,
		setStoresLoader,
		adminBootstrap,
		selectWebsiteForAdmin,
    channels,
    setChannels,
    channelsLoader,
    setChannelsLoader,
    bannerLoader,
    setBannerLoader,
    promoTileLoader,
    setPromoTileLoader,
    promoTiles,
    setPromoTiles,
    selectedPromoTiles,
    setSelectedPromoTiles,
    channelId,
    setChannelId,
    debouncedSearch,
    setDebouncedSearch,
    merchandisingError,
    setMerchandisingError,
    enableDynamic,
    setEnableDynamic,
    dynamicItems,
    setDynamicItems,
    triggerDynamic,
    setTriggerDynamic,
    newProducts,
    setNewProducts,
    addedProductIds,
    setAddedProductIds,
    addedProducts,
    setAddedProducts,
    newProductOrder,
    setNewProductOrder,
    dateRange,
    setDateRange,
    // Filter-related properties
    filterValues,
    setFilterValues,
    currentFilter,
    setCurrentFilter,
    getFilteredValues,
    updateFilterValues,
    updateCurrentFilter,
    applySortingToValues,
  };
  return (
    <ProductContext.Provider value={store}>
      {props.children}
    </ProductContext.Provider>
  );
};

export default ProductProvider;

